import { ProcessingView } from '@/components/progress/ProcessingView/ProcessingView';

export function ProcessingSummaryView() {
  return (
    <ProcessingView
      title="Summary in progress"
      subtitle="Summaries can take a few minutes to generate. You can exit this screen."
    />
  );
}
